import awsExport from '../aws-exports.js'
import { getToken } from './index.js'
import { API } from 'aws-amplify'
import { ECOM_DEALER_ADMIN_API } from '../api.js'
import { getApi } from './index.js'

export async function getDealers(market) {
  let datas,
    dealers = [],
    res = await fetch(
      awsExport.cdn_api + '/dealers/dealers-' + market + '.json'
    )

  if (res.status === 200) {
    datas = await res.json()
    for (let key in datas.dealers) {
      if (!_isInArray(dealers, datas.dealers[key].id)) {
        dealers.push({
          label: datas.dealers[key].name + ' - ' + datas.dealers[key].city,
          value: datas.dealers[key].id,
        })
      }
    }
  }

  let response = {
    error:
      res.status !== 200
        ? 'This market have no dealer registered for the moment'
        : '',
    dealers: dealers,
  }

  return response
}

export async function getAuthenticatedUser() {
  const Authorization = await getToken()
  const options = {
    headers: {
      Authorization,
      'X-API-Key': getApi(ECOM_DEALER_ADMIN_API).apiKey,
    },
  }

  try {
    const endpoint = 'sellers/v1/users/me'

    const response = await API.get(
      getApi(ECOM_DEALER_ADMIN_API).name,
      endpoint,
      options
    )
    return response
  } catch (e) {
    return
  }
}

export function getDealerNameById(ids, allDealers) {
  let dealersOpt = []
  const idSplit = ids.split(';')

  for (let i = 0; i < idSplit.length; i++) {
    for (let key in allDealers) {
      if (allDealers[key].value === idSplit[i])
        dealersOpt.push({ label: allDealers[key].label, value: idSplit[i] })
    }
  }

  return dealersOpt
}

function _isInArray(array, el) {
  let isInArray = false

  for (let key in array) {
    if (array[key].value === el) {
      isInArray = true
    }
  }

  return isInArray
}
